import { render, staticRenderFns } from "./DevicePage.vue?vue&type=template&id=f1ff8886&scoped=true&"
import script from "./DevicePage.vue?vue&type=script&lang=js&"
export * from "./DevicePage.vue?vue&type=script&lang=js&"
import style0 from "./DevicePage.vue?vue&type=style&index=0&id=f1ff8886&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ff8886",
  null
  
)

export default component.exports